/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSubCatalogByIdMutationVariables = Exact<{
  id: string;
}>;


export type DeleteSubCatalogByIdMutation = { delete_sub_catalog_by_pk: { id: string } | null };


export const DeleteSubCatalogByIdDocument = /*#__PURE__*/ gql`
    mutation DeleteSubCatalogById($id: uuid!) {
  delete_sub_catalog_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteSubCatalogByIdMutationFn = Apollo.MutationFunction<DeleteSubCatalogByIdMutation, DeleteSubCatalogByIdMutationVariables>;

/**
 * __useDeleteSubCatalogByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSubCatalogByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubCatalogByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubCatalogByIdMutation, { data, loading, error }] = useDeleteSubCatalogByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubCatalogByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubCatalogByIdMutation, DeleteSubCatalogByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubCatalogByIdMutation, DeleteSubCatalogByIdMutationVariables>(DeleteSubCatalogByIdDocument, options);
      }
export type DeleteSubCatalogByIdMutationHookResult = ReturnType<typeof useDeleteSubCatalogByIdMutation>;
export type DeleteSubCatalogByIdMutationResult = Apollo.MutationResult<DeleteSubCatalogByIdMutation>;
export type DeleteSubCatalogByIdMutationOptions = Apollo.BaseMutationOptions<DeleteSubCatalogByIdMutation, DeleteSubCatalogByIdMutationVariables>;